<p-toolbar>
  <div class="p-toolbar-group-start">
    <button pButton pRipple label="New" icon="pi pi-plus" class="p-button-primary mr-2" (click)="onNewClick()"></button>
  </div>
</p-toolbar>

<p-table #dt
         dataKey="id"         
         [value]="(data$ | async)!"
         [loading]="(isLoading$ | async)!"
         [totalRecords]="(dataCount$ | async)!"
         [lazy]="true"
         [rows]="10"
         [showCurrentPageReport]="true"
         [rowsPerPageOptions]="[10, 25, 50]"
         [paginator]="true"
         [globalFilterFields]="['ffl.name', 'ffl.phone', 'ffl.state']"
         [filterDelay]="250"
         [breakpoint]="'960px'"
         [rowHover]="true"
         (onLazyLoad)="onLazyLoad($event)"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
         sortField="ffl.name"
         sortMode="single"
         responsiveLayout="stack">
  <ng-template pTemplate="caption">
    <div class="flex">
      FFLs
      <span class="p-input-icon-left ml-auto">
        <i class="pi pi-search"></i>
        <input pInputText type="text" placeholder="Search keyword" (input)="applyFilterGlobal($event)" />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="min-width:15rem" pSortableColumn="ffl.name">
        <div class="flex align-items-center">
          Name
          <p-sortIcon field="ffl.name"></p-sortIcon>
          <p-columnFilter type="text" field="ffl.name" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="min-width:15rem" pSortableColumn="ffl.state">
        <div class="flex align-items-center">
          State
          <p-sortIcon field="ffl.state"></p-sortIcon>
          <p-columnFilter type="text" field="ffl.state" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="min-width:15rem" pSortableColumn="ffl.phone">
        <div class="flex align-items-center">
          Phone
          <p-sortIcon field="ffl.phone"></p-sortIcon>
          <p-columnFilter type="text" field="ffl.phone" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="min-width:15rem" pSortableColumn="ffl.willAcceptAllTransfers">
        <div class="flex align-items-center">
          Accept Transfers
          <p-sortIcon field="ffl.willAcceptAllTransfers"></p-sortIcon>
          <p-columnFilter type="text" field="ffl.willAcceptAllTransfers" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="width: 8rem"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-ffl>
    <tr [ngClass]="{'deleted-record': ffl.deleteDate}">
      <td>
        <span class="p-column-title"><strong>Name</strong></span>
        {{ffl.name}}
      </td>
      <td>
        <span class="p-column-title"><strong>State</strong></span>
        {{ffl.state}}
      </td>
      <td>
        <span class="p-column-title"><strong>Phone</strong></span>
        {{ffl.phone}}
      </td>
      <td>
        <span class="p-column-title"><strong>Accepts Transfers</strong></span>
        {{ffl.willAcceptAllTransfers}}
      </td>
      <td style="text-align: center">
        <button pButton
                pRipple
                icon="pi pi-pencil"
                class="p-button-rounded p-button-primary mr-2"
                (click)="openEntity(ffl.id)"
                pTooltip="Edit"
                tooltipPosition="left">
        </button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">No FFLs found.</td>
    </tr>
  </ng-template>
</p-table>
